import { apiQuery, deleteCommand, findOneCommand, queueQuery, updateCommand } from './templates';
import './angular-documentHelper';
import './obto-data-components';
import * as _ from 'underscore';
import NProgress from 'nprogress';
import * as beautify_js from 'js-beautify';
import { format } from "prettier/standalone";
import * as prettierPluginBabel from "prettier/plugins/babel";
import * as prettierPluginEstree from "prettier/plugins/estree";
import swal from 'sweetalert2';
import moment from 'moment-timezone';
import * as async from 'async';
import feather from 'feather-icons';
import uuidv4 from "uuidv4";
import LabelInformation from './components/LabelInformation';
import TimelineComponent from './components/Timeline';
import AlertComponent from './components/AlertComponent';
import FormTabs from './components/FormTabs';
import MonacoEditorComponent from './components/MonacoEditor';
import 'tinymce/tinymce.min';
import 'tinymce/themes/modern';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/skins/lightgray/skin.min.css';
import 'angular-ui-tinymce';
import './obto-data-service';
import { DocumentController } from './Document';
import { createRoot } from 'react-dom/client';
import * as React from "react";
window.feather = feather;
const bhtml = beautify_js.html;
const bcss = beautify_js.css;

export default angular.module('obto.data.document', ['ui.tinymce', 'document.helper', 'obto.components'])
    .controller('FormController', function () {
    })
    .controller('ModalInstanceCtrl3', ['$route', '$http', '$log', '$location', 'FetchRemote', '$scope', '$uibModalInstance', 'parentScope', 'name', 'API', 'rootScope', 'referCollection', 'action', 'field', function ($route, $http, $log, $location, FetchRemote, $scope, $uibModalInstance, parentScope, name, API, rootScope, referCollection, action, field) {
        $scope.fieldModel = {
            label: '',
            name: '',
            type: 'text'
        };
        $scope.docId = parentScope._docId;
        $scope.collection = parentScope.collection;
        $scope.doc = parentScope.values;
        $log.info('Domain being set: ' + parentScope.modifiedFieldValue.domain || rootScope.domain);
        parentScope.buttons.processing = true;
        $scope.dynamic = 50;
        $scope.rsectionFilter = {};
        $scope.columnName = [];//["Upload Date", "Document Id", "Filename", "Domain", "Content Type", "Collection", "ID", "Domain"];
        $scope.avatarsrc = parentScope.avatarsrc;
        $log.debug($scope.avatarsrc);

        //showattachments
        $scope.attachmentModel = ['filename', 'contentType'];
        const attachments = [];
        $scope.attachmentparams = {
            "shownavGrid": false,
            "pagesize": 10,
            "editenabled": false
        };

        if (name === "showattachments.html") {

            $scope.deleteAttachment = (attachment) => {
                // function cb(response) {
                //     $scope.dynamic = 100;
                //     if (response.status === 200) {
                //         $location.path("/" + $scope.collection + "/" + response.data._id).replace();
                //     } else {
                //         $scope.errorFlag = true;
                //         $scope.error_message = response.status + " : " + response.data.message;
                //         swal("Problem", JSON.stringify(response.data), "warning");
                //     }
                //     $scope.buttons.processing = false;
                //     $scope.modifiedFieldValue = {};
                //     NProgress.done();
                //     // $route.reload();
                // }

                // $log.debug("$scope.modifiedFieldValue====>" + JSON.stringify($scope.modifiedFieldValue));
                // NProgress.start();
                // $http.post("/o/" + $scope.collection + "/" + $scope._docId, $scope.modifiedFieldValue).then(cb);
            }


            API("pltf_file_store").query({
                oquery: `metadata.collection=${$scope.collection},metadata.documentId=${$scope.docId}`,
                stream: true,
                sort: "uploadDate",
                project: "uploadDate,metadata.documentId,filename,metadata.domain,contentType,metadata.collection,_id"
            }).$promise.then((myfiles) => {
                async.each(myfiles, (item, cb) => {
                    let fobj = {
                        "name": item.filename,
                        "size": 12345,
                        "type": item.contentType,
                        "link": "/o/pltf_file_store/" + item._id,
                        "url": "/o/pltf_file_store/" + item._id,
                        "_id": item._id
                    };

                    attachments.push(fobj);
                    cb();
                }, (err) => {
                    // NProgress.done();
                    // c(null, 2);
                    $scope.attachments = attachments;
                });
            });
        }

        $scope.apiDemoOptions = {
            allowSelect: true,
            allowResize: true,
            allowMove: true,
            animate: true,
            aspectRatio: 1,
            setSelect: [50, 0, 350, 300]
        };

        $scope.ok = function () {

        };

        $scope.destoryMember = () => {
            setTimeout(() => {
                rootScope.$emit("event.remove.subform");
            }, 400);
        };

        if (name === 'showsubform.html') {
            setTimeout(() => {
                rootScope.$emit("event.render.subform.started", referCollection);
            }, 700);
        }

        if (name === 'showdifferencechecker.html') {
            setTimeout(() => {
                // console.log($scope.docId);

                //fetch remote content
                const remoteObject = FetchRemote.query({ document_id: $scope.docId, name: $scope.doc.name, collection: $scope.collection });
                remoteObject.$promise.then(function (response) {
                    let remoteContent = "Not able to find a remote match";
                    if (response.length) {
                        remoteContent = response[0].script;
                    }
                    rootScope.$emit("event.render.difference.checker", {
                        documentId: $scope.docId,
                        content: parentScope.values.script,
                        remoteContent: remoteContent,
                        action,
                        modifiedFieldValue: parentScope.modifiedFieldValue,
                        field
                    });
                }).catch(e => {
                    console.log(e);
                });

            }, 500);
        }

        $scope.setDisplay = function (tab) {
            let fileterValue = $scope.docId;
            if (tab.filter && $scope.doc[tab.filter]) {
                fileterValue = $scope.doc[tab.filter];
            }

            if (tab.query_field && $scope.doc[tab.query_field]) {
                fileterValue = $scope.doc[tab.query_field];
            }

            return `<div id="table-{{tab._id}}" class="col-12"><jq-grid id="jqgridContainer-${tab._id}"
                     table="tab.on_collection" filter="tab.filter" filter-data="tab.filter"
                     column-model="tab.column_model"
                     fvalue=${fileterValue} domain="domain"
                     parentdiv="${tab._id}"
                     container=${tab._id}/></div>`;
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
            parentScope.buttons.processing = false;
            $scope.destoryMember();
        };

        if (name === 'addnewfield.html') {
            $log.debug(JSON.stringify(parentScope._csrf));
            $scope.fieldModel["_csrf"] = parentScope._csrf;
            $scope.fieldModel["oper"] = "add";
            $scope.fieldModel["list_view"] = true;
            $scope.fieldModel["list_order"] = 2;
            $scope.fieldModel["section_name"] = "main";
            $scope.fieldModel["form_view"] = true;
            $scope.fieldModel["collection_name"] = $scope.collection;

            $scope.$watch("fieldModel.type", function (n, o) {
                $log.debug(JSON.stringify($scope.fieldModel));
                $scope.fieldModel["input_type"] = $scope.fieldModel.type;
            });

            $scope.$watch("fieldModel.label", function (n, o) {
                $log.debug(JSON.stringify($scope.fieldModel));
                $scope.fieldModel.name = $scope.fieldModel.label.replace(/\s+/g, '_').toLowerCase();
            });

            $scope.createfield = function () {

                const request = $http({
                    method: "post",
                    url: "/o/pltf_field/", //$scope.values["_id"],
                    //transformRequest: transformRequestAsFormPost,
                    data: $scope.fieldModel
                });

                // Store the data-dump of the FORM scope.
                request.then(
                    function (response) {
                        //$log.log("Document updated");
                        $log.log("Field updated" + response.data);
                        parentScope.buttons.processing = false;
                        $uibModalInstance.close();

                        $.notify({
                            title: '<strong>Success!</strong>',
                            message: 'Field created'
                        }, {
                            type: 'success'
                        });

                    });

            };

        }

    }])
    .directive('member', ['$compile', '$rootScope', '$ngRedux', function ($compile, $rootScope, $ngRedux) {
        return {
            restrict: "E",
            replace: true,
            scope: {},
            templateUrl: $rootScope.viewFiles + '/nextpage.html',
            link: function (scope, element, attrs) {
                scope.isLoading = true;

                const deregister1 = $ngRedux.subscribe(() => {
                    let state = $ngRedux.getState();
                    if (typeof state.appState.isLoading !== "undefined") {
                        scope.isLoading = state.appState.isLoading;
                    }
                });

                const deregister7 = $rootScope.$on("event.remove.subform.modal", (e, data) => {
                    element.html('');
                    setTimeout(() => {
                        let _inject = `<obto-sub-form collection="${data.collection}" document="${data._id}" embedded="true">&nbsp;</obto-sub-form>`;
                        element.append(_inject);
                        $compile(element.contents())(scope);
                        $ngRedux.dispatch({
                            type: 'UPDATE',
                            payload: {
                                "isLoading": false
                            }
                        });
                    }, 200);
                });

                const deregister = $rootScope.$on("event.render.subform.started", (e, data) => {
                    let inject = `<obto-sub-form collection=${data.collection} document=${data.value} embedded="true">&nbsp;</obto-sub-form>`;

                    if (data.type && data.type === "list") {
                        scope.collection = data.collection;
                        scope.filterData = data.filter;
                        scope.gridOptions = { "embedded": true, searchEnabled: false, memberView: true };
                        scope.columnModel = "";

                        inject = `<div id="sub-list" class="col-12"><jq-grid id="jqgridContainer-sub-list"
                     table="collection" filter="filterData"
                     filter-data="filterData" column-model="columnModel"
                     fvalue="" domain="dev" grid-options="gridOptions"
                     parentdiv="sub-list"
                     container="sub-list"/></div>`;
                    }
                    element.append($compile(inject)(scope));
                    // setDisplay
                    setTimeout(() => {
                        $rootScope.$broadcast("event:grid:sub-list");
                        // $rootScope.$broadcast("event:resize:calendar");
                    }, 1200);
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            "isLoading": false
                        }
                    });
                });

                const deregister2 = $rootScope.$on("event.render.difference.checker", (e, data) => {
                    scope.contentref = data.content;
                    scope.remotecontentref = data.remoteContent;
                    scope.submitForm = data.action; //save the parent form
                    scope.modifiedFieldValue = data.modifiedFieldValue;
                    scope.field = data.field;
                    // console.log(scope.field);
                    let inject = `<obto-difference-checker document-id="${data.documentId}" ng-model="modifiedFieldValue[field.name]" submit-form="submitForm()" contentref="contentref" remote-content-ref="remotecontentref">&nbsp;</obto-difference-checker>`;
                    element.append($compile(inject)(scope));
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            "isLoading": false
                        }
                    });
                });

                const deregister3 = $rootScope.$on("event.render.help.support", (e, data) => {
                    setTimeout(() => {
                        let inject = `<obto-template name="platform_support" dev-controls="false"><!-- --></obto-template>`;
                        element.append($compile(inject)(scope));
                        $ngRedux.dispatch({
                            type: 'UPDATE',
                            payload: {
                                "isLoading": false
                            }
                        });
                    }, 200);
                });

                //chat
                const deregister4 = $rootScope.$on("event.render.connect", (e, data) => {
                    let inject = `<obto-template name="ob-connect" dev-controls="false"><!-- --></obto-template>`;
                    element.append($compile(inject)(scope));
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            "isLoading": false
                        }
                    });
                });

                const deregister5 = $rootScope.$on("event.render.appmanager.html", (e, data) => {
                    let inject = `<obto-template name="appmanager.html" dev-controls="false"><!-- --></obto-template>`;
                    element.append($compile(inject)(scope));
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            "isLoading": false
                        }
                    });
                });

                const deregister6 = $rootScope.$on("event.render.collectionmanagerv3", (e, data) => {
                    let inject = `<obto-template name="collectionmanagerv3" dev-controls="false"><!-- --></obto-template>`;
                    element.append($compile(inject)(scope));
                    $ngRedux.dispatch({
                        type: 'UPDATE',
                        payload: {
                            "isLoading": false
                        }
                    });
                });

                //field options
                // const deregister8 = $rootScope.$on("event.render.fieldoptions", (e, data) => {
                //     scope.paylod = {
                //         "fieldName": data.fieldName,
                //             "collection": data.collection
                //     };
                //     let inject = `<obto-template name="field-options" dev-controls="false" parent-data="paylod"><!-- --></obto-template>`;
                //     element.append($compile(inject)(scope));
                //     $ngRedux.dispatch({
                //         type: 'UPDATE',
                //         payload: {
                //             "isLoading": false
                //         }
                //     });
                // });

                const deregister9 = $rootScope.$on("event.remove.subform", () => {
                    scope.$destroy();
                });

                scope.$on('$destroy', function () {
                    deregister();
                    deregister1();
                    deregister7();
                    deregister2();
                    deregister3();
                    deregister4();
                    deregister5();
                    deregister6();
                    deregister9();
                    // deregister8();
                });

            }
        };
    }])
    .directive('obtoForm', ['$window', '$timeout', '$compile', 'pageService', '$http', '$routeParams', '$rootScope', '$location', 'ribbon', '$uibModal', 'API', '$localstorage', '$log', '$anchorScroll', 'OB', '$route', '$document', '$ngRedux',
        function ($window, $timeout, $compile, pageService, $http, $routeParams, $rootScope, $location, ribbon, $uibModal, API, $localstorage, $log, $anchorScroll, OB, $route, $document, $ngRedux) {
            return {
                replace: true,
                restrict: 'A',
                controllerAs: 'documentCtrl',
                controller: ['$window', '$timeout', '$compile', 'pageService', '$http', '$routeParams', '$rootScope', '$location', 'ribbon', '$uibModal', 'API', '$localstorage', '$log', '$anchorScroll', 'OB', '$route', '$document', '$ngRedux', '$scope', DocumentController],
                templateUrl: $rootScope.viewFiles + '/form-base.html?v=' + $rootScope.oversion,
                link: function ($scope, element, attrs, ctrl, transclude) {
                    try {
                        feather.replace({
                            width: 18,
                            height: 18,
                        });

                    } catch (e) {

                    }

                    $scope.whichCodeEditor = $localstorage.getObject("ob.props")['co.obto.platform.code.editor'] || "ace";
                    const serverScripts = {};
                    const clientScripts = {};
                    let matchScriptNames = "";
                    $scope.showSubForm = false;
                    $scope.dnd = false;
                    $scope.attachments = [];
                    $scope.fields = {};
                    $scope.ui_actions = [];
                    $scope.values = {};
                    $scope._oldValues = {};
                    $scope._newValues = {};
                    $scope.fieldValue = {};
                    $scope.reactComponent = "";
                    $scope.fieldOption = {};
                    $scope.allFieldsOption = {};
                    $scope.infoMessage = "Sample instructions";
                    $scope.infoFlag = true;
                    $scope.actionVisible = {};
                    $scope.modifiedFieldValue = {};
                    $scope.onChangeFunction = [];
                    $scope.onLoadFunction = {};
                    $scope.dependency = [];
                    $scope.fieldVisibility = {};
                    $scope.isHidden = {}; //To hide fieldsth
                    $scope.fieldDisabled = {}; //To make field readonly//ng-disabled="disableDate(field.name)"
                    $scope.fieldRequired = {}; //To make field required
                    $scope.fieldCSS = {}; //To change field css
                    $scope.successFlag = false;
                    $scope.errorFlag = false;
                    $scope.success_message = "";
                    $scope.remoteUpdated = {};
                    $scope.remoteBeingViewed = {};
                    $scope.error_message = "";
                    $scope.inputModel = [];
                    $scope.form = {};
                    $scope.collection = $routeParams.document || attrs.collection;
                    $scope.gridOptions = {
                        gridHeight: 'auto',
                        embedded: true
                    };
                    const normalizeFieldMap = {};
                    const normalizedFieldsObject = {};
                    const o = {
                        root: $rootScope,
                        scope: $scope,
                        timeout: $timeout,
                        http: $http,
                        window: $window,
                        moment: moment,
                        _: _,
                        routeParams: $routeParams,
                        scrollTo: $anchorScroll,
                        location: $location,
                        modal: $uibModal,
                        async: async,
                        API: API,
                        localStorage: $localstorage,
                        service: OB
                    };

                    const collection = $routeParams.document || attrs.collection;
                    const document = $routeParams.id || attrs.document;
                    $scope.input = {
                        collection,
                        document
                    };
                    $scope.editor = {};
                    $scope.aceeditor = {};
                    const remoteUpdated = {};
                    $scope.buttons = {};
                    $scope.error_message = "Please check the required fields.";
                    $scope.currentMode = {};
                    $scope.posts = [];
                    $scope._docId = $routeParams.id || attrs.document;
                    $scope.fieldModel = {};
                    $scope.showTabs = {};
                    $scope.editableOptions = {
                        mode: 'popup',
                        disabled: false
                    };
                    $scope.username = 'superuser';
                    $scope.gridOptions = { "embedded": true, searchEnabled: false, memberView: true };
                    $scope.viewMainForm = $rootScope.viewFiles + '/form-main.html?v=' + $rootScope.oversion;
                    $scope.activityComponent = $rootScope.viewFiles + '/post-colab.html?v=' + $rootScope.oversion;

                    $scope.setDisplay = function (tab) {

                        let fileterValue = $scope.docId;
                        if (tab.filter && $scope.values[tab.filter]) {
                            fileterValue = $scope.values[tab.filter];
                        }

                        if (tab.query_field && $scope.values[tab.query_field]) {
                            fileterValue = $scope.values[tab.query_field];
                        }
                        //If tab.filter is an object(key,value) then fvalue is ignored.
                        //filter_data is deprecated
                        //filter-data="tab.filter_data"

                        return `<div id="table-{{tab._id}}"><jq-grid id="jqgridContainer-${tab._id}"
                        table="tab.on_collection" filter="tab.filter" filter-data="tab.filter" grid-options="gridOptions"
                        column-model="tab.column_model"
                        fvalue=${fileterValue} domain="domain"
                        parentdiv="${tab._id}"
                        container=${tab._id}/></div>`;
                    };

                    $scope.mode = "html";
                    $scope.editorView = { 'height': '700px' };
                    const allProps = $localstorage.getObject("ob.props");
                    let USE_SCRIPT_1 = null;
                    let response_data_ui_actions;
                    let _docId = "";
                    let oper = "";
                    let error = false;
                    let formConnected = false;
                    let documenyViewInterval;
                    let userChangeTriggred = false;
                    let deRegister2 = () => {
                    };
                    let deRegister3 = () => {
                    };
                    let deregister4 = () => {
                    };
                    let deregister6 = () => {
                    };
                    let deregister7 = () => {
                    };
                    const remoteBeingViewed = {};

                    const deregister5 = $scope.$on("$destroy", () => {
                        formConnected = false;
                        deRegister3();
                        deRegister2();
                        deRegister();
                        deregister4();
                        deregister5();
                        deregister6();
                        deregister7();
                        $log.info("Unsubscribing..." + `${$scope.values.domain}/document/update/${$scope._docId}`);
                        $ngRedux.dispatch({
                            type: 'UPDATE',
                            payload: {
                                "formReady": false
                            }
                        });
                        try {
                            $window.client.unsubscribe(`${$scope.values.domain}/document/view/${$scope._docId}`);
                            $window.client.unsubscribe(`${$scope.values.domain}/document/update/${$scope._docId}`);
                            clearInterval(documenyViewInterval)
                        } catch (e) {

                        }
                    });

                    $scope.organize = () => {
                        $scope.dnd = !$scope.dnd;

                        if ($scope.dnd) {
                            $scope.dragSpace = { 'background-color': '#F7CA18' };
                            $scope.draggableDiv = { 'margin': '10px' };
                            $scope.droppableCss = {
                                'height': '60px',
                                'width': '100%',
                                'border-color': 'rgb(101, 94, 94)',
                                'border-width': '2px',
                                'border-style': 'dashed',
                                'margin-left': '2px'
                            };
                        } else {
                            $scope.dragSpace = {};
                            $scope.droppableCss = {};
                        }
                    }

                    deregister6 = $scope.$watch('dnd', function (n, o) {
                        console.log(n, o);
                        if (n) {
                            $scope.dragSpace = { 'background-color': '#F7CA18' };
                            $scope.draggableDiv = { 'margin': '10px' };
                            $scope.droppableCss = {
                                'height': '60px',
                                'width': '100%',
                                'border-color': 'rgb(101, 94, 94)',
                                'border-width': '2px',
                                'border-style': 'dashed',
                                'margin-left': '2px'
                            };
                        } else {
                            $scope.dragSpace = {};
                            $scope.droppableCss = {};
                        }
                    });

                    const deRegister = $ngRedux.subscribe(() => {

                        let state = $ngRedux.getState();
                        if (state.appState.formReady) {
                            let templateName = collection;
                            let targetPages = ['ob-connect', 'sofos-notice-board', 'imitate', 'ob-domains', 'switchdomain', 'changesets'];
                            setTimeout(() => {
                                if (targetPages.indexOf(templateName) === -1) {
                                    let title = templateName.replace(/[_-]/g, " ");
                                    title = title.replace("pltf", "").trim();
                                    title = title.replace(".html", "").trim();
                                    title = title.replace("v2", "").trim();
                                    title = title.charAt(0).toUpperCase() + title.slice(1);
                                    $rootScope.$broadcast('event:titlechanged', title);
                                }
                            }, 400);

                            if (Object.keys($scope.onLoadFunction).length !== 0) {
                                const _o = {
                                    root: $rootScope,
                                    scope: $scope,
                                    timeout: $timeout,
                                    http: $http,
                                    window: $window,
                                    moment: moment,
                                    _: _,
                                    routeParams: $routeParams,
                                    // beautify: bjs,
                                    scrollTo: $anchorScroll,
                                    location: $location,
                                    modal: $uibModal,
                                    async: async,
                                    API: API,
                                    localStorage: $localstorage,
                                    service: OB
                                };

                                async.eachSeries($scope.onLoadFunction, (element, _cb) => {
                                    let USE_SCRIPT = null;
                                    try {
                                        $scope.$eval(new Function("try { " + element._func + "} catch(err){ console.log(err)}")()($scope, $rootScope, _o, $scope.aceeditor));
                                    } catch (e) {
                                        $log.log(e);
                                        console.error(element.name, JSON.stringify(e));
                                    }
                                    _cb();
                                }, err => {
                                    $scope.$applyAsync();
                                });
                            }
                        }
                    });

                    $scope.tinymceModel = 'Initial content';

                    $scope.getContent = function () {
                        $log.debug('Editor content:', $scope.tinymceModel);
                    };

                    $scope.setContent = function () {
                        $scope.tinymceModel = 'Time: ' + (new Date());
                    };

                    $scope.tinymceOptions = {
                        plugins: 'link image code, fullscreen',
                        height: "480",
                        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code | fullscreen',
                        init_instance_callback: function (editor) {
                            editor.on('Change', function (e) {
                                $log.debug('Editor contents was changed.');
                                $log.debug(editor.getContent());
                                $scope.modifiedFieldValue['script'] = editor.getContent();
                            });
                        }
                    };

                    function validate() {
                        angular.forEach($scope.obtoform, function (control, name) {
                            // Excludes internal angular properties
                            if (typeof name === 'string' && name.charAt(0) !== '$') {
                                // To display ngMessages
                                control.$setTouched();
                                // Runs each of the registered validators
                                control.$validate();
                            }
                        });
                    }

                    $scope.resetUiActions = (on_change) => {
                        const ui_actions = response_data_ui_actions;
                        const actionVisible = {};
                        $log.debug("ui_actions", ui_actions);
                        ui_actions.map(val => {
                            const USE_SCRIPT = (val.compiled) ? val.compiled.code : val.handler;
                            actionVisible[val._id] = false;
                            val.handler = () => {
                                // const originalModifiedObject = $scope.modifiedFieldValue;
                                new Function(`try { ${USE_SCRIPT} return _func(); } catch(err) { console.log(${val.name}, err)}`)()(o);
                                validate();
                                $timeout(() => {
                                    $scope.submitForm(val._id);
                                }, 300);
                            };

                            if (val.condition) {
                                const field_values = on_change ? $scope.modifiedFieldValue : $scope.values;
                                try {
                                    actionVisible[val._id] = new Function(`try { ${val.condition} } catch(err) { console.log(${val.name}, err)}`)()(o, field_values);
                                    $log.debug("actionVisible", actionVisible);
                                } catch (e) {
                                    // throw e;
                                    $log.error(e);
                                }
                            }

                            return val;
                        });
                        $scope.ui_actions = ui_actions;
                        $scope.actionVisible = Object.assign($scope.actionVisible, actionVisible);
                    };

                    $scope.fetchFieldAt = (map) => {
                        return normalizeFieldMap[map] ? normalizeFieldMap[map] : false;
                    };

                    const form = {};
                    const sectionValid = {};
                    let formRow = [];

                    $scope.renderTabs = (key) => {
                        console.log(key);
                        // $scope.showTabs[key] = true;
                    }

                    const fetchFormStructure = (c) => {
                        $http.get(`/o/form/${collection}/${document}`).then((response) => {
                            if (response.status === 200) {
                                $scope._docId = document;
                                const values = {};
                                response.data.sections.map((sec) => {
                                    form[sec.name] = [];
                                    sectionValid[sec.name] = true;
                                    $scope.showTabs[sec.name] = false;
                                    sec.classes = 'ob-tab-required';
                                    const fields = response.data.fields.filter(val => val.section_name === sec.name).sort((a, b) => (parseInt(a.row_id) - parseInt(b.row_id) || parseInt(a.column_id) - parseInt(b.column_id)));
                                    // console.log('fields', fields);
                                    fields.forEach((field, fieldIndex) => {
                                        const fn = field.name;
                                        remoteUpdated[fn] = false;
                                        if (field.input_type === 'code') {

                                        }


                                        $scope.fieldValue[field.name] = "";
                                        if (!normalizeFieldMap[field.map]) {
                                            normalizeFieldMap[field.map] = field;
                                        }

                                        if (!normalizedFieldsObject[field.name]) {
                                            normalizedFieldsObject[field.name] = field;
                                        }

                                        if (field.input_type === 'option') {
                                            const fieldOptions = response.data.option.filter(val => val.field === field.name);
                                            fieldOptions.unshift({ id: '', name: 'None', field: field.name });
                                            $scope.fieldOption[field.name] = fieldOptions;
                                            $scope.allFieldsOption[field.name] = $scope.fieldOption[field.name];
                                            values[field.name] = '';
                                        }

                                        if ($scope._docId === "new" && field.default_value) {
                                            values[field.name] = field.default_value;
                                            $scope.modifiedFieldValue[field.name] = field.default_value;
                                        }

                                        let isFullLength = false;
                                        if (['document_editor', 'code', 'tarea'].includes(field.input_type)) {
                                            isFullLength = true;
                                        }

                                        if (isFullLength && !formRow.length) {
                                            formRow.push(field);
                                            form[sec.name].push(formRow);
                                            formRow = [];
                                        }

                                        if (isFullLength && formRow.length) {
                                            form[sec.name].push(formRow);
                                            formRow = [];
                                            formRow.push(field);
                                            form[sec.name].push(formRow);
                                            formRow = [];
                                        }

                                        if (!isFullLength && formRow.length === 1 && field.row_id !== formRow[0].row_id) {
                                            form[sec.name].push(formRow);
                                            formRow = [];
                                        }

                                        !isFullLength && formRow.push(field);

                                        if (formRow.length === 2) {
                                            form[sec.name].push(formRow);
                                            formRow = [];
                                        }

                                        if (fields.length === fieldIndex + 1 && formRow.length <= 2) {
                                            form[sec.name].push(formRow);
                                            formRow = [];
                                        }
                                    });

                                    return sec;
                                });

                                if (response.data.data.length) {
                                    _.extend(values, response.data.data[0]);
                                }

                                $scope.form = form;

                                $scope.sections = response.data.sections;
                                $scope.sectionValid = sectionValid;
                                $scope.values = values;
                                //Enable RC to have data access
                                $scope.input.values = values;
                                _.extend($scope, response.data);
                                response_data_ui_actions = response.data.ui_actions;
                                $scope.rsections = ($scope._docId === "new") ? [] : $scope.rsections;
                                c(null, 1);
                            }
                        });
                    };

                    const fetchRecord = (c) => {
                        if (document !== "new") {
                            $scope.isUpdate = true;
                            $scope.isInsert = false;
                            if (!_.isUndefined(collection)) {
                                $scope.resetUiActions(false);
                                c(null, 2);
                            }
                        } else {
                            c(null, 2);
                        }
                    };

                    const initiate = [fetchFormStructure, fetchRecord];

                    const loadDocument = (n, o) => {
                        $log.info('Loading data');
                        // NProgress.start();
                        if (typeof n === 'undefined') {
                            // NProgress.done();
                            return false;
                        }

                        if ($scope._docId === "new" || Object.keys($scope.values).length !== 0) {
                            async.each($scope.fields, (v, cb) => {
                                let fo = v;
                                const fn = fo.name;
                                $scope.fieldCSS[fn] = "input-group"; //(!fo.mandatory) ? "input-group" : "input-group has-error";
                                $scope.fieldValue[fn] = $scope.values[fn] || "";
                                try {
                                    if ($scope.values[fn] && $scope.values[fn].indexOf('{{ORIGIN}}') > -1) {
                                        $scope.fieldValue[fn] = $scope.values[fn].replace('{{ORIGIN}}', window.location.origin);
                                    }
                                } catch (e) {
                                    console.log(fn);
                                }
                                $scope.fieldRequired[fn] = _.isUndefined(fo.mandatory) ? false : fo.mandatory; //false;
                                $scope.fieldDisabled[fn] = _.isUndefined(fo.readonly) ? false : fo.readonly; //false;
                                $scope.isHidden[fn] = !(fo.form_view && fo.form_view.toString() === 'true');
                                if (['updated_on', 'updated_by', 'created_on', 'created_by'].includes(fn)) {
                                    $scope.fieldDisabled[fn] = true;
                                }

                                if (fn === 'domain')
                                    $scope.fieldDisabled[fo.name] = true;

                                if (typeof $scope.aceeditor[fn] !== 'undefined' && Object.keys($scope.aceeditor[fn]).length && fo.input_type === 'code') {
                                    let setMode = "";
                                    if ($scope.values.modes) {
                                        setMode = $scope.values.modes[fn] || 1;
                                    } else {
                                        setMode = $scope.values.mode || 1;
                                    }
                                    // let setMode = $scope.values.modes[fn] || 1;
                                    const _script = $scope.values[fn] || 'return { key: "Your Imagination At Work!"}';
                                    if (typeof _script === 'string') {
                                        $scope.editor[fn].code = $scope.values[fn];
                                    }
                                    if (typeof _script === 'object') {
                                        $scope.editor[fn].code = JSON.stringify($scope.values[fn]);
                                    }
                                    $scope.currentMode[fn] = parseInt(setMode);
                                    $scope.aceeditor[fn].getSession().setMode("ace/mode/" + $scope.viewMode(setMode).toLowerCase());
                                }

                                if (fo.input_type === 'document_editor') {
                                    const _script = $scope.values[fn] || 'Initial content';
                                    if (typeof _script === 'string') {
                                        $scope.fieldValue[fn] = $scope.values[fn];
                                    }
                                    if (typeof _script === 'object') {
                                        $scope.fieldValue[fn] = JSON.stringify($scope.values[fn]);
                                    }
                                }

                                if (fo.input_type === 'datetime') {
                                    $scope.fieldValue[fn] = (typeof $scope.values[fn] !== "undefined") ? new Date($scope.values[fn]) : "";
                                    return cb();
                                }

                                if (fo.input_type === 'date') {
                                    const setValue = (typeof $scope.values[fn] !== "undefined") ? new Date($scope.values[fn]) : ""; //$scope.values[fo.name] || new Date();
                                    $scope.fieldPops[fn] = {
                                        opened: false
                                    };
                                    $scope.fieldValue[fn] = setValue;
                                    return cb();
                                }

                                if (fo.input_type === 'checkbox') {
                                    if (typeof $scope.values[fn] === 'undefined') {
                                        $scope.fieldValue[fn] = false;
                                        return cb();
                                    }

                                    $scope.fieldValue[fn] = $scope.values[fn] && $scope.values[fn].toString() === "true";

                                    return cb();
                                }

                                if (fo.input_type === 'image') {
                                    $scope.fieldValue[fn] = "data:image/jpg;base64," + window.btoa($scope.values[fn]);
                                }

                                //Check if I am a dependent field
                                const dependentFields = $scope.fields.filter(val => val.dependency === fn);
                                dependentFields.forEach((val) => {
                                    // console.log("$scope.allFieldsOption[val.name];", val.name);
                                    const allFieldsOptions = $scope.allFieldsOption[val.name];
                                    const dependentFieldName = fn;
                                    const dependentFieldValue = $scope.fieldValue[fn];
                                    if (!dependentFieldValue) {
                                        $scope.fieldOption[val.name] = $scope.allFieldsOption[val.name];
                                        return;
                                    }
                                    if (allFieldsOptions) {
                                        $scope.fieldOption[val.name] = allFieldsOptions.filter(val => val.dependent_field === dependentFieldName && val.filter === dependentFieldValue);
                                    } else {
                                        $scope.fieldOption[val.name] = [];
                                    }

                                });//Divy

                                cb();
                            }, (e) => {

                                if ($scope._docId !== "new") {

                                    $scope.remoteUpdated = {};

                                    deregister4 = $ngRedux.subscribe(() => {
                                        let state = $ngRedux.getState();
                                        if (state.appState.events && state.appState.events.event === `event:${$scope.values.domain}/document/update/${$scope._docId}`) {
                                            const data = state.appState.events.data.msg;
                                            $scope.remoteUpdated = {};
                                            let _remoteUpdated = {};
                                            Object.keys(data.payload).forEach(key => {
                                                _remoteUpdated[key] = true;
                                                if (key === "error") {
                                                    $scope.successFlag = false;
                                                    $scope.errorFlag = true;
                                                    $scope.error_message = data.payload[key].status + " : " + data.payload[key].message;
                                                    return;
                                                }
                                                if (key === "updated_on") {
                                                    $scope.fieldValue[key] = new Date(data.payload[key]);
                                                } else {
                                                    $scope.fieldValue[key] = data.payload[key];
                                                }
                                            });
                                            $scope.remoteUpdated = _remoteUpdated;
                                            // $scope.$applyAsync();
                                            try {
                                                feather.replace({
                                                    width: 18,
                                                    height: 18,
                                                });
                                            } catch (e) {

                                            }
                                        }
                                    });

                                    deRegister2 = $ngRedux.subscribe(() => {
                                        let state = $ngRedux.getState();
                                        if (state.appState.events && state.appState.events.event === `event:${$scope.values.domain}/document/view/${$scope._docId}`) {
                                            remoteBeingViewed[state.appState.events.data.msg.from] = state.appState.events.data;

                                            const getInitialsPayload = { first: "", last: "" };
                                            const name = (state.appState.events.data.msg.fromName) ? state.appState.events.data.msg.fromName.split(" ") : ["OBTO", "User"];
                                            getInitialsPayload.first = name[0];
                                            getInitialsPayload.last = (name[1]) ? name[1] : "";
                                            remoteBeingViewed[state.appState.events.data.msg.from].dp = OB.getInitials(getInitialsPayload);

                                            $scope.remoteBeingViewed = remoteBeingViewed;
                                            // $scope.$applyAsync();
                                        }
                                    });

                                    deRegister3 = $ngRedux.subscribe(() => {
                                        let state = $ngRedux.getState();
                                        if (state.login.socketStatus && state.login.socketStatus.status === 'ready' && !formConnected) {
                                            if ($scope._docId !== 'new' && typeof $window.client === 'object') {
                                                $window.client.subscribe(`${$scope.values.domain}/document/update/${$scope._docId}`);
                                                $window.client.subscribe(`${$scope.values.domain}/document/view/${$scope._docId}`);
                                                $window.client.publish(`${$scope.values.domain}/document/view/${$scope._docId}`, JSON.stringify({
                                                    uid: uuidv4(),
                                                    msg: {
                                                        dp: $rootScope.user.display_picture_url,
                                                        from: $rootScope.user._id,
                                                        domain: $rootScope.ob.domain,
                                                        fromName: $rootScope.user.name
                                                    }
                                                }));
                                                documenyViewInterval = setInterval(() => {
                                                    $window.client.publish(`${$scope.values.domain}/document/view/${$scope._docId}`, JSON.stringify({
                                                        uid: uuidv4(),
                                                        msg: {
                                                            dp: $rootScope.user.display_picture_url,
                                                            from: $rootScope.user._id,
                                                            domain: $rootScope.ob.domain,
                                                            fromName: $rootScope.user.name
                                                        }
                                                    }));
                                                }, 10000);
                                                $log.info("Client Subscribing..." + `${$scope.values.domain}/document/update/${$scope._docId}`);
                                                formConnected = true;
                                            }
                                        }
                                    });

                                } else {

                                    if (!_.isUndefined($scope.collection))
                                        userChangeTriggred = true;

                                    $scope.isUpdate = false;
                                    $scope.isInsert = true;
                                    $http.get("/o/sequence.bto/" + collection).then((response) => {
                                        if (response.status === 200) {
                                            if ($scope.fieldValue.hasOwnProperty('sequence')) {
                                                $scope.fieldValue["sequence"] = response.data.value;
                                                $scope.modifiedFieldValue["sequence"] = response.data.value;
                                            }
                                            if ($scope.fieldValue.hasOwnProperty('number')) {
                                                $scope.fieldValue["number"] = response.data.value;
                                                $scope.modifiedFieldValue["number"] = response.data.value;
                                            }

                                        } else {
                                            $log.log('Error');
                                        }
                                        NProgress.done();
                                    });
                                }

                                userChangeTriggred = true;
                                const linkFn = $compile();
                                const content = linkFn($scope);
                                element.append(content);
                                $scope.activeTab = 1;
                                $scope.reactComponent = FormTabs;
                                NProgress.done();
                                $ngRedux.dispatch({
                                    type: 'UPDATE',
                                    payload: {
                                        "formReady": true
                                    }
                                });
                            });
                        }
                    };

                    const saveFile = (name, type, data) => {
                        if (data != null && navigator.msSaveBlob)
                            return navigator.msSaveBlob(new Blob([data], { type: type }), name);
                        let a = $("<a style='display: none;'/>");
                        let url = window.URL.createObjectURL(new Blob([data], { type: type }));
                        a.attr("href", url);
                        a.attr("download", name);
                        $("body").append(a);
                        a[0].click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                    };

                    const jsonView = () => {
                        "use strict";
                        let jsonViewCb = async (response) => {

                            "use strict";
                            let newWindow = window.open();

                            //write the data to the document of the newWindow
                            const formatted = await format(JSON.stringify(response.data), {
                                parser: "babel",
                                plugins: [prettierPluginBabel, prettierPluginEstree],
                                jsxBracketSameLine: true
                            });

                            $timeout(() => {
                                newWindow.document.write('<pre style="background: darkslateblue;\n' +
                                    '    color: white;white-space: pre-wrap;\n' +
                                    '    padding: 30px;">' + formatted + '</pre>');
                            }, 100);
                        };
                        $http.get(`/jsonexport/${$scope.collection}/${$scope._docId}`, {
                            // responseType: "arraybuffer"
                        }).then(jsonViewCb);
                    };

                    const pdfView = () => {
                        "use strict";

                    };

                    const jsonDownload = () => {
                        "use strict";

                        const jsonCb = (response) => {

                            saveFile($scope.collection + ".json", "data:attachment/json", response.data);
                        };

                        swal({
                            title: "Are you sure?",
                            text: "You gotta do what you gotta do",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Yes, download it!",
                            cancelButtonText: "No, cancel plz!"
                        }).then((result) => {
                            if (result.value) {
                                $http.get(`/jsonexport/${$scope.collection}/${$scope._docId}`, {
                                    responseType: "arraybuffer"
                                }).then(jsonCb);
                                swal("Success", "Your file is open right next window :)", "success");
                            } else {
                                swal("Cancelled", "Your imaginary file is safe :)", "error");
                            }
                        });
                    };

                    $scope.actions = {
                        jsonView: jsonView,
                        pdfView: pdfView,
                        jsonDownload: jsonDownload
                    };

                    $scope.getTextAreaWidth = function ($event) {
                        $scope.width = $($event.target).parent().outerWidth();
                        alert($scope.width);

                    };

                    $scope.reply = "";

                    $scope.avatarsrc = "";

                    $scope.transformDate = function (d) {
                        const format = $rootScope.globalAttributes['co.obto.domain.datetime.format'] || "MMMM Do YYYY h:mm:ss a";
                        return moment.tz(d, 'Asia/Kolkata').format(format);
                    };

                    $scope._changedField = "updated_on";

                    $scope._sequencer = false;

                    deregister7 = $scope.$watch('fieldValue[_changedField]', function (newValue, oldValue) {
                        if (newValue !== oldValue && userChangeTriggred) {
                            $scope._oldValues = $scope.fieldValue;
                            $scope._newValues = $scope.modifiedFieldValue;
                            $log.debug($scope._changedField + ' oldValue=' + JSON.stringify($scope._oldValues));
                            $log.debug($scope._changedField + ' newValue=' + JSON.stringify($scope._newValues));
                        }
                    }, true);

                    $scope.updateFieldValue = function (field, value) {
                        $log.debug(field + '==CALLED==' + value);
                        $scope._changedField = field;
                        $scope.fieldValue[field] = value;
                    };

                    $scope.change = function (field) {
                        $scope._changedField = field;
                        $scope.modifiedFieldValue[field] = $scope.fieldValue[field];
                        // $log.info("$scope.fieldValue[field]======>" + $scope.fieldValue[field]);
                        $scope.onChangeFunction.forEach(function (element, index, _function) {
                            if (_function[index].field === field) {
                                try {
                                    $scope.$eval(new Function("try { " + _function[index]._func + "} catch(err){ console.log(err)}")()($scope._oldValues, $scope._newValues, $scope, o, $scope.aceeditor));
                                } catch (e) {
                                    console.error(element.name, JSON.stringify(e));
                                }
                            }

                        });

                        //Check if I am a dependent field
                        const dependentFields = $scope.fields.filter(val => val.dependency === field);
                        dependentFields.forEach((val) => {
                            const allFieldsOptions = $scope.allFieldsOption[val.name];
                            const dependentFieldName = field;
                            const dependentFieldValue = $scope.modifiedFieldValue[dependentFieldName];
                            if (!dependentFieldValue) {
                                $scope.fieldOption[val.name] = $scope.allFieldsOption[val.name];
                                return;
                            }
                            $scope.fieldOption[val.name] = allFieldsOptions.filter(val => val.dependent_field === dependentFieldName && val.filter === dependentFieldValue);
                        });

                        if ($scope.fieldValue[field] && $scope.fieldValue[field] !== "") {
                            $scope.obtoform.$setDirty();
                            $scope.resetUiActions(false);
                        }

                    };

                    $scope.foldAll = function (fn) {
                        $scope.aceeditor[fn].getSession().foldAll();
                    };

                    $scope.unfold = function (fn) {
                        $scope.aceeditor[fn].getSession().unfold();
                    };

                    $scope.format = async function (fn) {

                        let script = $scope.aceeditor[fn].getSession().getValue();
                        let formatted = "";

                        if ($scope.currentMode[fn] === 2) {

                            formatted = await format(script, {
                                parser: "babel",
                                jsxBracketSameLine: true,
                                plugins: [prettierPluginBabel, prettierPluginEstree],
                            });

                            $scope.aceeditor[fn].getSession().setValue(formatted);
                            return;
                        }

                        if ($scope.currentMode[fn] === 1) {
                            formatted = await format(script, {
                                parser: "babel",
                                jsxBracketSameLine: true,
                                plugins: [prettierPluginBabel, prettierPluginEstree],
                            });
                        }

                        if ($scope.currentMode[fn] === 3) {
                            formatted = bhtml(script, {
                                indent_size: 2,
                                indent_char: " "
                            });
                        }

                        if ($scope.currentMode[fn] === 4) {
                            formatted = bcss(script, {
                                indent_size: 2,
                                indent_char: " "
                            });
                        }

                        $scope.aceeditor[fn].getSession().setValue(formatted);

                    };

                    $scope.setTemplate = async function (fn, t) {

                        let tmp = "";
                        switch (t) {
                            case 1:
                                tmp = await format(apiQuery, {
                                    parser: "babel",
                                    jsxBracketSameLine: true,
                                    plugins: [prettierPluginBabel, prettierPluginEstree],
                                });
                                $scope.aceeditor[fn].session.insert($scope.aceeditor[fn].getCursorPosition(), tmp);
                                break;

                            case 5:
                                tmp = await format(deleteCommand, {
                                    parser: "babel",
                                    jsxBracketSameLine: true,
                                    plugins: [prettierPluginBabel, prettierPluginEstree]
                                });
                                $scope.aceeditor[fn].session.insert($scope.aceeditor[fn].getCursorPosition(), tmp);
                                break;

                            case 6:
                                tmp = await format(findOneCommand, {
                                    parser: "babel",
                                    jsxBracketSameLine: true,
                                    plugins: [prettierPluginBabel, prettierPluginEstree],
                                });
                                $scope.aceeditor[fn].session.insert($scope.aceeditor[fn].getCursorPosition(), tmp);
                                break;

                            case 7:
                                tmp = await format(updateCommand, {
                                    parser: "babel",
                                    jsxBracketSameLine: true,
                                    plugins: [prettierPluginBabel, prettierPluginEstree],
                                });
                                $scope.aceeditor[fn].session.insert($scope.aceeditor[fn].getCursorPosition(), tmp);
                                break;

                            case 8:
                                tmp = await format(queueQuery, {
                                    parser: "babel",
                                    jsxBracketSameLine: true,
                                    plugins: [prettierPluginBabel, prettierPluginEstree],
                                });
                                $scope.aceeditor[fn].session.insert($scope.aceeditor[fn].getCursorPosition(), tmp);
                                break;

                            default:
                                $scope.aceeditor[fn].session.insert($scope.aceeditor[fn].getCursorPosition(), "");

                        }
                    };

                    $scope.appMode = function (fn, m) {
                        if ($scope.values.modes) {
                            $scope.modifiedFieldValue.modes = {};
                            $scope.modifiedFieldValue.modes = $scope.values.modes;
                        } else {
                            $scope.modifiedFieldValue.modes = {};
                        }
                        if (m === 1) {
                            $scope.currentMode[fn] = 1;
                            $scope.modifiedFieldValue.mode = 1;

                            $scope.modifiedFieldValue.modes[fn] = 1;
                            $scope.aceeditor[fn].getSession().setMode("ace/mode/javascript");
                        }


                        if (m === 2) {
                            $scope.modifiedFieldValue.mode = 2;
                            $scope.modifiedFieldValue.modes[fn] = 2;
                            $scope.aceeditor[fn].getSession().setMode("ace/mode/jsx");
                            $scope.currentMode[fn] = 2;
                        }

                        if (m === 3) {
                            $scope.modifiedFieldValue.mode = 3;
                            $scope.modifiedFieldValue.modes[fn] = 3;
                            $scope.aceeditor[fn].getSession().setMode("ace/mode/html");
                            $scope.currentMode[fn] = 3;
                        }

                        if (m === 4) {
                            $scope.modifiedFieldValue.mode = 4;
                            $scope.aceeditor[fn].getSession().setMode("ace/mode/css");
                            $scope.currentMode[fn] = 4;
                            $scope.modifiedFieldValue.modes[fn] = 4;
                        }

                        if (m === 6) {
                            $scope.modifiedFieldValue.mode = 2;
                            $scope.modifiedFieldValue.modes[fn] = 2;
                            $scope.aceeditor[fn].getSession().setMode("ace/mode/jsx");
                            $scope.currentMode[fn] = 2;
                        }

                    };

                    $scope.user = {
                        name: 'Hello'
                    };

                    function getFieldLabel(field) {
                        if (!field || !field.$name) return 'Unknown Field';

                        var element = $document[0].querySelector('[name="' + field.$name + '"]');

                        if (element && element.getAttribute('data-label')) {
                            return element.getAttribute('data-label');
                        }

                        // Fallback if no label is provided
                        return field.$name;
                    }

                    $scope.submitForm = (actionId = false) => {
                        $scope.obtoform.$setPristine();
                        if (!$scope.obtoform.$valid || $scope.obtoform.$invalid) {
                            $scope.errorFlag = true;
                            $log.info($scope.fieldValue);
                            $log.info($scope.obtoform.$error);
                            $log.info($scope.obtoform);
                            $scope.errorList = []; // reset
                            const trackedFields = {}; // to avoid duplicate messages
                            const actionVisible = {};
                            angular.forEach($scope.obtoform.$error, function (fields, errorType) {
                                angular.forEach(fields, function (field) {
                                    if (field && field.$name && !trackedFields[field.$name + '-' + errorType]) {
                                        // console.log(field);
                                        var label = getFieldLabel(field);
                                        var message = '';

                                        if (errorType === 'required') {
                                            message = label + ' is required';
                                        } else if (errorType === 'email') {
                                            message = label + ' must be a valid email address';
                                        } else if (errorType === 'minlength') {
                                            message = label + ' does not meet the minimum length';
                                        } else if (errorType === 'maxlength') {
                                            message = label + ' exceeds the maximum allowed length';
                                        } else {
                                            message = label + ' is invalid (' + errorType + ').';
                                        }

                                        $scope.errorList.push(message);

                                        // Mark this field+errorType as processed
                                        trackedFields[field.$name + '-' + errorType] = true;
                                    }
                                });
                            });

                            // console.log('trackedFields', trackedFields);
                            $scope.error_message = $scope.errorList.join(", ");
                            if (actionId) {
                                actionVisible[actionId] = true;
                                $scope.actionVisible = Object.assign($scope.actionVisible, actionVisible);
                                console.log($scope.actionVisible);
                                $scope.resetUiActions();
                                $ngRedux.dispatch({
                                    type: 'UPDATE',
                                    payload: {
                                        "formReady": true
                                    }
                                });
                            }
                            return swal("Problem", `Required field is empty! \n ${$scope.error_message}`, "error");
                        }
                        NProgress.start();

                        function cb(response) {
                            $scope.dynamic = 100;
                            if (response.status === 200) {
                                $scope.successFlag = true;
                                $scope.success_message = "Record updated";
                                $location.path("/" + $scope.collection + "/" + response.data._id).replace();
                            } else {
                                $scope.errorFlag = true;
                                $scope.error_message = response.status + " : " + response.data.message;
                                swal("Problem", JSON.stringify(response.data), "warning");
                            }
                            $scope.buttons.processing = false;
                            $scope.modifiedFieldValue = {};
                            NProgress.done();
                            // $route.reload();
                        }

                        $scope.modifiedFieldValue["domain"] = $scope.values['domain'] || $rootScope.ob.domain;
                        $log.debug("$scope.modifiedFieldValue====>" + JSON.stringify($scope.modifiedFieldValue));
                        $http.post("/o/" + $scope.collection + "/" + $scope._docId, $scope.modifiedFieldValue).then(cb);

                    };

                    $scope.setAvatar = function () {
                    };

                    $scope.dateOptions = {
                        formatYear: 'yy',
                        startingDay: 1,
                        formatDay: 'dd',
                        formatMonth: 'mm'
                    };

                    let dformat = "dd-MM-yyyy";
                    let pickerFormat = $rootScope.globalAttributes['co.obto.domain.date.format'];
                    if (pickerFormat === 'mm/dd/yy' || pickerFormat === 'mm-dd-yy')
                        dformat = 'MM-dd-yyyy';

                    $scope.dateFormat = dformat; //$rootScope.globalAttributes['co.obto.domain.date.format'];

                    $scope.fieldPops = {};

                    $scope.date = {
                        value: new Date(),
                        showFlag: false
                    };

                    $scope.open2 = function (name) {
                        $log.info(name);
                        $scope.fieldPops[name].opened = true;
                    };

                    $scope.goBack = function () {
                        $timeout(function () {
                            //$location.path(decodeURIComponent($rootScope._lurl), true);
                            $location.path($scope.collection + "/list");
                        }, 50);
                        //$location.replace();
                    };

                    $scope.sync = function () {
                        $scope.copied = angular.copy($scope.fieldValue);
                        $scope.copied['_csrf'] = $scope._csrf;
                        $scope.copied['oper'] = "add";
                        $scope.copied['domain'] = $rootScope.domain;

                        $http.post("/o/sync.bto/", {
                            collection: $scope.collection,
                            _csrf: $scope._csrf
                        }).then(function (response) {
                            "use strict";

                        });

                    };

                    $scope.cni = function () {
                        $scope.copied = angular.copy($scope.fieldValue);
                        $scope.copied['_csrf'] = $scope._csrf;
                        $scope.copied['oper'] = "add";
                        $scope.copied['domain'] = $rootScope.domain;
                        $log.debug("Copied " + JSON.stringify($scope.copied));

                        if ($scope.copied.hasOwnProperty('sequence') || $scope.copied.hasOwnProperty('number')) {
                            $http.get("/o/sequence.bto/" + $scope.collection).then(function (response) {
                                $log.debug(response);
                                if (response.status === 200) {
                                    if ($scope.copied.hasOwnProperty('sequence')) {
                                        $scope.copied["sequence"] = response.value;
                                    }
                                    if ($scope.copied.hasOwnProperty('number')) {
                                        $scope.copied["number"] = response.value;
                                    }

                                }
                                executeThis();

                            });
                        } else {
                            executeThis();
                        }

                    };

                    const executeThis = function () {

                        function cb(response) {
                            //console.log("RESPOSNE :" + JSON.stringify(response))
                            $scope.dynamic = 100;

                            if (response.status === 200) {
                                $scope.successFlag = true;
                                $scope.success_message = "Record copied and inserted.";

                                swal({
                                    title: "View Copied Record",
                                    text: "Would you like to view record?",
                                    type: "success",
                                    showCancelButton: true,
                                    cancelButtonClass: "btn-default",
                                    confirmButtonText: "View",
                                    confirmButtonClass: "btn-primary"
                                }).then((result) => {
                                    if (result.value) {
                                        $timeout(function () {
                                            // swal.close();
                                            $location.path($scope.collection + "/" + response.data._id).replace();
                                        }, 100);
                                    } else {
                                        // swal("Cancelled", "Copy & Insert Action Cancelled.", "error");
                                    }
                                });

                            } else {
                                $scope.errorFlag = true;
                                $scope.error_message = response.status + " : " + response.data.message;
                                swal("Problem", response.data, "warning");
                            }

                            $scope.copied = {};

                        }

                        swal({
                            title: "Are you sure?",
                            text: "Would you like to copy and insert this record?",
                            type: "info",
                            showCancelButton: true,
                            cancelButtonClass: "btn-default",
                            confirmButtonText: "Copy",
                            confirmButtonClass: "btn-primary"
                        }).then((result) => {
                            if (result.value) {
                                $http.post("/o/" + $scope.collection + "/", $scope.copied).then(cb);
                            } else {
                                swal("Cancelled", "Copy & Insert Action Cancelled.", "error");
                            }
                        });
                    };

                    $scope.handleDrop = function (item, bin, obin, iobin) {

                        // let modalinstance = $scope.open('mapupdate.html');

                        let toBePosted = [];

                        let firstChange = {};
                        firstChange._id = item;
                        firstChange._csrf = $scope._csrf;
                        firstChange._oldValue = obin;
                        firstChange.domain = $rootScope.domain;
                        firstChange.map = bin;
                        firstChange.row_id = bin.split("-")[2];
                        firstChange.column_id = bin.split("-")[3];
                        firstChange.id = "1";
                        firstChange.oper = "edit";

                        //console.log("Data to be posted : " + JSON.stringify(firstChange));
                        //toBePosted.push(firstChange);
                        let request = $http({
                            method: "post",
                            url: "/o/pltf_field",
                            data: JSON.stringify(firstChange)
                        });

                        request.then(
                            function (html) {
                                //$log.log("Map updated");
                                $scope.success_message = "Map updated";
                                $scope.successFlag = true;
                                if (iobin === null)
                                    modalinstance.close();

                            });

                        let secondChange = {};
                        secondChange._id = iobin;
                        secondChange._csrf = $scope._csrf;
                        secondChange._oldValue = bin;
                        secondChange.domain = $rootScope.domain;
                        secondChange.map = obin;
                        secondChange.row_id = obin.split("-")[2];
                        secondChange.column_id = obin.split("-")[3];
                        secondChange.id = "1";
                        secondChange.oper = "edit";
                        //console.log("Data to be posted : " + JSON.stringify(secondChange));
                        //toBePosted.push(secondChange);
                        if (iobin !== null) {
                            let request2 = $http({
                                method: "post",
                                url: "/o/pltf_field",
                                data: JSON.stringify(secondChange)
                            });

                            request2.then(
                                function (html) {
                                    $log.log("Map updated");
                                    $scope.success_message = "Map updated";
                                    $scope.successFlag = true;
                                    modalinstance.close();

                                });
                        }

                    };

                    $scope.updateUserImage = function (name) {
                        $scope.modifiedFieldValue[name] = "";
                        $scope.modifiedFieldValue[name] = window.atob($scope.fieldValue[name].split(',')[1]);
                    };

                    $scope.convertImage = (name) => {
                        return "data:image/jpg;base64," + window.btoa($scope.fieldValue[name]);
                    };

                    $scope.open = function (name, field, fieldValue, useFor = null, action = () => { }) {
                        let size = 'xl';

                        if (name === "relation.html" || name === "showattachments.html" || name === "notifynow.html" || name === "avatar.html") {
                            NProgress.done();
                            size = 'xl';
                        }

                        const document = $scope.values;
                        let modalInstance = $uibModal.open({
                            templateUrl: name,
                            controller: 'ModalInstanceCtrl3',
                            size: size,
                            windowTopClass: 'obto-modal-document right',
                            // openedClass: 'modal-dialog-slideout',
                            animation: false,
                            resolve: {
                                parentScope: function () {
                                    return $scope;
                                },
                                name: function () {
                                    return name;
                                },
                                action: () => {
                                    return action;
                                },
                                rootScope: function () {
                                    return $rootScope;
                                },
                                docId: function () {
                                    return _docId;
                                },
                                payload: function () {
                                    if (useFor && useFor === 'differenceChecker') {
                                        return {};
                                    }
                                },
                                field: () => {
                                    return field
                                },
                                fieldValue: function () {
                                    $scope.modifiedFieldValue["oper"] = oper;
                                    $scope.modifiedFieldValue["domain"] = $scope.values['domain'] || $rootScope.domain;
                                    return $scope.modifiedFieldValue;
                                },
                                referCollection: function () {
                                    if (field && typeof field === "object" && field.input_type === "gselect" && field.refer_collection) {
                                        return {
                                            collection: field.refer_collection,
                                            value: fieldValue[field.name].value
                                        };
                                    }

                                    if (field && fieldValue) {
                                        return {
                                            collection: field,
                                            value: fieldValue
                                        };
                                    }

                                    return {
                                        collection: "",
                                        value: ""
                                    };

                                }
                            }
                        });

                        if (name === "mapupdate.html")
                            return modalInstance;

                        modalInstance.result.then(function (selectedItem) {
                        }, function () {
                            $log.info('Modal dismissed at: ' + new Date());
                            $scope.buttons.processing = false;
                        });
                    };

                    $scope.tabSelected = (tabId) => {
                        setTimeout(() => {
                            console.log("event:grid:" + tabId);
                            $rootScope.$broadcast("event:grid:" + tabId);
                            $rootScope.$broadcast("event:resize:calendar");
                        }, 600);
                    };

                    const ready = (err, result) => {
                        console.log(err, result);
                        $scope.access = {};
                        $scope.access.upload = false;
                        $scope.access.download = false;
                        $scope.access.addfield = false;
                        $scope.access.json = true;
                        $scope.access.addfield = true;

                        try {
                            const userRoles = $localstorage.getObject("ob").user.roles;

                            if (userRoles.indexOf("oad") > -1 || userRoles.indexOf("admin") > -1) {
                                $scope.access.upload = true;
                                $scope.access.download = true;
                                $scope.access.addfield = true;
                                $scope.access.json = true;
                                $scope.access.addfield = true;
                                $scope.access.form_admin = true;
                            }

                            if (userRoles.indexOf("download") > -1) {
                                $scope.access.download = true;
                            }

                            if (userRoles.indexOf("form_admin") > -1) {
                                $scope.access.form_admin = true;
                            }
                        } catch (e) {

                            console.log(e);

                        }

                        $scope.editurl = false;
                        $scope.flipUrlState = () => {
                            $scope.editurl = !$scope.editurl;
                        };
                        const viewSections = () => {
                            $log.info($scope.collection);
                            const _url = `/pltf_collection_section/list?_search=true&nd=${new Date().getTime()}&rows=25&page=1&sidx=updated_on&sord=desc&project=name,active,action,collection,execution_time,order,domain,script,created_on,created_by,version,app,_id,domain&collection_name=${$scope.collection}`;
                            $location.url(_url);
                            // $location.search('collection', $scope.collection);
                        };

                        const viewRelations = () => {
                            $log.info($scope.collection);
                            $rootScope.openv3('formrelations', null, {
                                collection: 'form_relation',
                                type: 'list',
                                filter: { collection: $scope.collection }
                            });
                        };

                        $scope.actions = {
                            jsonView: jsonView,
                            pdfView: pdfView,
                            jsonDownload: jsonDownload,
                            viewSections,
                            viewRelations
                        };
                        $log.info('Ready');
                        $http.get('/o/recs/pltf_script_server?project=name,_id&oquery=active=true&stream=true').then((response) => {

                            if (response.status === 200 || response.data.length !== 0) {

                                async.eachSeries(response.data, (code, cb) => {
                                    serverScripts[code.name] = code._id;
                                    cb();
                                }, (err) => {

                                    try {
                                        matchScriptNames = Object.keys(serverScripts).map(val => {
                                            return `${val}`;
                                        });
                                    } catch (e) {

                                    }

                                    loadDocument(document, '');
                                });

                            }
                        });
                    };

                    NProgress.start();

                    async.series(initiate, ready);

                }
            };
        }
    ])
    .directive('candrag', ['$compile', '$log', function ($compile, $log) {
        return {
            //restrict: 'A',
            scope: {
                dnd: '='
            },
            link: function (scope, element) {
                // this gives us the native JS object
                //element.attr('draggable', '');
                scope.$watch('dnd', function (n) {
                    if (n) {
                        $log.debug("Can Drag:" + n);
                        //element.attr('draggable', 'draggable');
                        let el = element[0];

                        el.draggable = true;

                        el.addEventListener(
                            'dragstart',
                            function (e) {
                                e.dataTransfer.effectAllowed = 'move';
                                e.dataTransfer.setData('Text', this.id);
                                $log.debug("Being dragged : " + this.id);
                                this.classList.add('drag');
                                return false;
                            },
                            false
                        );

                        el.addEventListener(
                            'dragend',
                            function (e) {
                                this.classList.remove('drag');
                                return false;
                            },
                            false
                        );
                        element.removeAttr("candrag");
                        //$compile(element.contents())(scope);
                        //$compile(element)(scope);
                    } else {
                        //console.log("Can Drag2:" + n);
                        element.removeAttr("draggable");
                        //$compile(element)(scope);
                    }

                });

                //$compile(element)(scope);
            }
        };
    }])
    .directive('draggable', function () {
        return {
            restrict: 'A',
            //scope: {
            //
            //},
            link: function (scope, element) {
                // this gives us the native JS object
                let el = element[0];

                el.draggable = true;

                el.addEventListener(
                    'dragstart',
                    function (e) {
                        e.dataTransfer.effectAllowed = 'move';
                        e.dataTransfer.setData('Text', this.id);
                        // console.log("Being dragged : " + this.id);
                        this.classList.add('drag');
                        return false;
                    },
                    false
                );

                el.addEventListener(
                    'dragend',
                    function (e) {
                        this.classList.remove('drag');
                        return false;
                    },
                    false
                );
            }
        };
    })
    .directive('droppable', function () {
        return {
            scope: {
                drop: '&',
                bin: '=',
                swap: '@'
            },
            link: function (scope, element) {
                // again we need the native object
                let el = element[0];

                el.addEventListener(
                    'dragover',
                    function (e) {
                        e.dataTransfer.dropEffect = 'move';
                        // allows us to drop
                        if (e.preventDefault) e.preventDefault();
                        this.classList.add('over');
                        return false;
                    },
                    false
                );

                el.addEventListener(
                    'dragenter',
                    function (e) {
                        this.classList.add('over');
                        return false;
                    },
                    false
                );

                el.addEventListener(
                    'dragleave',
                    function (e) {
                        this.classList.remove('over');
                        return false;
                    },
                    false
                );

                el.addEventListener(
                    'drop',
                    function (e) {
                        // Stops some browsers from redirecting.
                        if (e.stopPropagation) e.stopPropagation();

                        this.classList.remove('over');

                        let binId = this.id;
                        let item = document.getElementById(e.dataTransfer.getData('Text'));
                        // console.log(item);
                        let originalParentNode = item ? item.parentNode : null;
                        // console.log(originalParentNode);
                        let itemAtOriginalBin = this.childNodes[0] ? this.childNodes[0].nextElementSibling : null;
                        // console.log(itemAtOriginalBin);

                        item && this.appendChild(item);

                        // console.log("Element original DIV :" + originalParentNode);
                        // console.log("Element that needs to be swapped : " + itemAtOriginalBin);

                        if (itemAtOriginalBin !== null && scope.swap) {
                            originalParentNode.appendChild(itemAtOriginalBin);
                        }

                        // call the passed drop function
                        scope.$apply(function (scope) {
                            let fn = scope.drop();
                            if ('undefined' !== typeof fn && itemAtOriginalBin !== null) {
                                fn(item.id, binId, originalParentNode.id, itemAtOriginalBin.id, item, e);
                            } else {
                                fn(item.id, binId, originalParentNode.id, null, item, e);
                            }
                        });

                        return false;
                    },
                    false
                );
            }
        };
    })
    .directive('postColab', ['$compile', 'pageService', '$http', '$rootScope', 'moment', '$log', 'ScriptLoader', function ($compile, pageService, $http, $rootScope, moment, $log, ScriptLoader) {
        return {
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                collection: '=',
                document: '@',
                posts: '=',
                append: '&',
                csrf: '='
            },
            controllerAs: 'ctrl',
            controller: function ($scope) {
            },
            templateUrl: $rootScope.viewFiles + '/postbase.html',
            link: function (scope, element, attrs, ctrl, transclude) {

                scope.FormTimeline = "";
                $http.get("/o/recs/post" + "?sort=created_on&oquery=collection=" + scope.collection + ",document=" + scope.document + "&stream=true&nd=" + new Date().getTime()).then(function (response) {
                    scope.posts = response.data;
                    ScriptLoader.load().then(CS => {
                        scope.FormTimeline = CS.FormTimelineComponent;
                    });
                });


                scope.post = function () {
                    if (scope.document === "new")
                        return;

                    const newPost = {
                        "comment": scope.thisPost, //"This is new one",
                        "created_on": new Date(),
                        "from": { "label": $rootScope.ob.user.name, "value": $rootScope.userid },
                        "updated_on": new Date(),
                        "domain": $rootScope.domain,
                        "updated_by": $rootScope.username,
                        "created_by": $rootScope.username,
                        "collection": scope.collection,
                        "document": scope.document, //"55762a16b3e8aa431c2f9a1b",
                        "reply_chain": "",
                        "_csrf": scope.csrf
                    };

                    //scope.posts.push(newPost);

                    let request = $http({
                        method: "post",
                        url: "/o/post/new", //$scope.values["_id"],
                        //transformRequest: transformRequestAsFormPost,
                        data: newPost
                    });

                    // Store the data-dump of the FORM scope.
                    request.then(
                        function (response) {
                            $log.log("Document updated");
                            // console.log("Post updated" + JSON.stringify(response.data));
                            newPost._id = response.data._id;
                            newPost.created_on = moment.tz(newPost.created_on, 'Asia/Kolkata').format('MM-DD-YYYY HH:mm:ss:SSS');
                            scope.posts.push(newPost);
                            scope.thisPost = "";
                            $.notify({
                                title: 'Success',
                                message: 'Comment updated'
                            }, {
                                placement: {
                                    from: "bottom",
                                    align: "right"
                                },
                                allow_dismiss: false,
                                type: 'minimalist',
                                delay: 4000,
                                icon_type: 'image',
                                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                                    '<img data-notify="icon" class="img-circle pull-left">' +
                                    '<span data-notify="title">{1}</span>' +
                                    '<span data-notify="message">{2}</span>' +
                                    '</div>'
                            });


                        });


                };

                transclude(scope.$parent, function (clone, scope) {

                    scope.append = function (id, reply) {
                        let newPost = {
                            //"_id": "55712eccb0f65c240380bea9",
                            "comment": reply, //"This is new one",
                            "created_on": new Date(), //moment().format('MM-DD-YYYY HH:mm:ss:SSS'),
                            "from": { "label": $rootScope.ob.user.name, "value": $rootScope.userid },
                            "updated_on": new Date(),
                            "domain": $rootScope.domain,
                            "updated_by": $rootScope.username,
                            "created_by": $rootScope.username,
                            "collection": scope.collection,
                            "document": scope.$parent._docId, //document,//"55762a16b3e8aa431c2f9a1b",
                            "reply_chain": { "label": "Post", "value": id },
                            "_csrf": $rootScope._csrf
                        };

                        let request = $http({
                            method: "post",
                            url: "/o/post/new",
                            data: newPost
                        });

                        // Store the data-dump of the FORM scope.
                        request.then(
                            function (response) {
                                //$log.log("Document updated");
                                newPost.created_on = moment.tz(newPost.created_on, 'Asia/Kolkata').format($rootScope.globalAttributes['co.obto.domain.datetime.format']);
                                scope.posts.push(newPost);
                                $log.debug("Post Length : " + scope.posts.length);
                                scope.reply = "";
                                $.notify({
                                    title: 'Success',
                                    message: 'Comment updated'
                                }, {
                                    placement: {
                                        from: "bottom",
                                        align: "right"
                                    },
                                    allow_dismiss: false,
                                    type: 'minimalist',
                                    delay: 4000,
                                    icon_type: 'image',
                                    template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                                        '<img data-notify="icon" class="img-circle pull-left">' +
                                        '<span data-notify="title">{1}</span>' +
                                        '<span data-notify="message">{2}</span>' +
                                        '</div>'
                                });
                            });

                    };

                    scope.countcomments = function (parentPost) {
                        // if ($scope.posts.length !== 0) {

                        let count = _.filter(scope.posts, (e) => {
                            return e.reply_chain.value === parentPost;
                        });
                        // console.log(count)
                        return count.length;
                        // }
                    };
                });
            }
        };
    }])
    .directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        try {
                            scope.$eval(attrs.ngEnter);
                        } catch (e) {
                            console.error(e);
                        }
                    });
                    event.preventDefault();
                }
            });
        };
    })
    .filter('spostFilter', function () {
        return function (items, parentPost) {
            if (!_.isUndefined(items)) {

                let filtered = [];
                _.each(items, function (e, i, arr) {
                    if (e.reply_chain.value === parentPost && e.reply_chain.toString().length !== 0) {
                        //console.log("parentApp" + parentApp);
                        filtered.push(e);
                    }
                });
                return filtered;
            }
        };
    })
    .directive("connectfile", ['$timeout', function ($timeout) {
        return {
            scope: {
                filereadimage: "=",
                cb: "&"
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    let reader = new FileReader();
                    changeEvent.preventDefault();
                    reader.onload = function (loadEvent) {

                        if (changeEvent.target.files[0].size > 10000000) {
                            return swal("Photo too large. Please upload a photo under 1MB.");
                        }
                        // console.log(loadEvent.target.result);
                        // scope.filereadimage = loadEvent.target.result;
                        scope.$digest(function () {
                            scope.filereadimage = loadEvent.target.result;
                            $timeout(scope.cb, 50);
                            // scope.cb(scope.filereadimage);
                        });

                    };
                    reader.readAsDataURL(changeEvent.target.files[0]);

                });
            }
        };
    }])
    .directive("connectimage", ['$timeout', function ($timeout) {
        return {
            scope: {
                filereadimage: "=",
                cb: "&"
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    let reader = new FileReader();
                    changeEvent.preventDefault();
                    reader.onload = function (loadEvent) {

                        if (changeEvent.target.files[0].size > 10000000) {
                            return swal("Photo too large. Please upload a photo under 1MB.");
                        }

                        scope.$digest(function () {
                            scope.filereadimage = loadEvent.target.result;
                            $timeout(scope.cb, 50);
                        });

                    };
                    reader.readAsDataURL(changeEvent.target.files[0]);

                });
            }
        };
    }])
    .directive("uploadimage", ['$timeout', function ($timeout) {
        return {
            scope: {
                filereadimage: "=",
                fieldname: "@",
                updatefieldvalue: "&",
                avatarsrc: "=",
                setAvatar: "&"
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    // console.log(scope.fieldname)
                    changeEvent.preventDefault();
                    let reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        // console.log(changeEvent.target.files[0].size);

                        if (changeEvent.target.files[0].size > 2000000) {
                            return swal("Photo too large. Please upload a photo under 200KB.");
                        }
                        let img = document.getElementById('image-' + scope.fieldname);
                        img.src = loadEvent.target.result;
                        scope.avatarsrc = loadEvent.target.result;
                        scope.filereadimage[scope.fieldname] = loadEvent.target.result;
                        // console.log("Calling controller function");
                        $timeout(scope.updatefieldvalue);

                    };
                    console.log(changeEvent.target);
                    reader.readAsDataURL(changeEvent.target.files[0]);

                });
            }
        };
    }])
    .directive('smartJcrop', ['$q', '$log', function ($q, $log) {
        return {
            restrict: 'A',
            scope: {
                coords: '=',
                options: '=',
                selection: '='
            },
            link: function (scope, element, attributes) {
                let jcropApi, imageWidth, imageHeight, imageLoaded = $q.defer();

                let listeners = {
                    onSelectHandlers: [],
                    onChangeHandlers: [],
                    onSelect: function (c) {
                        angular.forEach(listeners.onSelectHandlers, function (handler) {
                            handler.call(jcropApi, c);
                        });
                    },
                    onChange: function (c) {
                        $log.debug(JSON.stringify(c));
                        angular.forEach(listeners.onChangeHandlers, function (handler) {
                            handler.call(jcropApi, c);
                        });
                    }
                };

                if (attributes.coords) {
                    let coordsUpdate = function (c) {

                        scope.$digest(function () {
                            scope.coords = c;
                        });
                    };
                    listeners.onSelectHandlers.push(coordsUpdate);
                    listeners.onChangeHandlers.push(coordsUpdate);
                }

                let $previewPane = $(attributes.smartJcropPreview),
                    $previewContainer = $previewPane.find('.preview-container'),
                    $previewImg = $previewPane.find('img');

                if ($previewPane.length && $previewImg.length) {
                    let previewUpdate = function (coords) {
                        if (parseInt(coords.w) > 0) {
                            let rx = $previewContainer.width() / coords.w;
                            let ry = $previewContainer.height() / coords.h;
                            $previewImg.css({
                                width: Math.round(rx * imageWidth) + 'px',
                                height: Math.round(ry * imageHeight) + 'px',
                                marginLeft: '-' + Math.round(rx * coords.x) + 'px',
                                marginTop: '-' + Math.round(ry * coords.y) + 'px'
                            });
                        }
                    };
                    listeners.onSelectHandlers.push(previewUpdate);
                    listeners.onChangeHandlers.push(previewUpdate);
                }


                let options = {
                    onSelect: listeners.onSelect,
                    onChange: listeners.onChange
                };

                if ($previewContainer.length) {
                    options.aspectRatio = $previewContainer.width() / $previewContainer.height();
                }

                if (attributes.selection) {
                    scope.$watch('selection', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            let rectangle = newVal === 'release' ? [imageWidth / 2, imageHeight / 2, imageWidth / 2, imageHeight / 2] : newVal;

                            let callback = newVal === 'release' ? function () {
                                jcropApi.release();
                            } : angular.noop;

                            imageLoaded.promise.then(function () {
                                if (scope.options && scope.options.animate) {
                                    jcropApi.animateTo(rectangle, callback);
                                } else {
                                    jcropApi.setSelect(rectangle);
                                }
                            });
                        }
                    });
                }

                if (attributes.options) {

                    let optionNames = [
                        'bgOpacity', 'bgColor', 'bgFade', 'shade', 'outerImage',
                        'allowSelect', 'allowMove', 'allowResize',
                        'aspectRatio'
                    ];

                    angular.forEach(optionNames, function (name) {
                        if (scope.options[name])
                            options[name] = scope.options[name];

                        scope.$watch('options.' + name, function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                imageLoaded.promise.then(function () {
                                    let update = {};
                                    update[name] = newVal;
                                    jcropApi.setOptions(update);
                                });
                            }
                        });

                    });


                    scope.$watch('options.disabled', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            if (newVal) {
                                jcropApi.disable();
                            } else {
                                jcropApi.enable();
                            }
                        }
                    });

                    scope.$watch('options.destroyed', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            if (newVal) {
                                jcropApi.destroy();
                            } else {
                                _init();
                            }
                        }
                    });

                    scope.$watch('options.src', function (newVal, oldVal) {
                        imageLoaded = $q.defer();
                        if (newVal !== oldVal) {
                            jcropApi.setImage(scope.options.src, function () {
                                imageLoaded.resolve();
                            });
                        }
                    });

                    let updateSize = function () {
                        jcropApi.setOptions({
                            minSize: [scope.options.minSizeWidth, scope.options.minSizeHeight],
                            maxSize: [scope.options.maxSizeWidth, scope.options.maxSizeHeight]
                        });
                    };

                    scope.$watch('options.minSizeWidth', function (newVal, oldVal) {
                        if (newVal !== oldVal) updateSize();
                    });
                    scope.$watch('options.minSizeHeight', function (newVal, oldVal) {
                        if (newVal !== oldVal) updateSize();
                    });
                    scope.$watch('options.maxSizeWidth', function (newVal, oldVal) {
                        if (newVal !== oldVal) updateSize();
                    });
                    scope.$watch('options.maxSizeHeight', function (newVal, oldVal) {
                        if (newVal !== oldVal) updateSize();
                    });
                }

                let _init = function () {
                    element.Jcrop(options, function () {
                        jcropApi = this;
                        // Use the API to get the real image size
                        let bounds = this.getBounds();
                        imageWidth = bounds[0];
                        imageHeight = bounds[1];

                        if (attributes.selection && angular.isArray(scope.selection)) {
                            if (scope.options && scope.options.animate) {
                                jcropApi.animateTo(scope.selection);
                            } else {
                                jcropApi.setSelect(scope.selection);
                            }
                        }
                        imageLoaded.resolve();
                    });
                };

                _init();


            }
        };
    }])
    // .directive('obLabelInfo', function () {
    //     return {
    //         link: function (scope, element, attrs) {
    //             let root;
    //             const reactComponentRef = React.createRef();
    //             element.on('click', function () {
    //                 // var currentElement = document.getElementById("myElement");
    //                 const nextElement = element[0].nextElementSibling;
    //                 // console.log('I got clicked', nextElement);
    //                 // console.log(attrs);
    //                 // Assuming you want to render the React component inside this element
    //                 // console.log(LabelInformation);
    //                 if (!root) {
    //                     // console.log(1);
    //                     root = createRoot(nextElement);
    //                     root.render(<LabelInformation name={attrs} ref={reactComponentRef} />);
    //                 }

    //                 if (reactComponentRef.current) {
    //                     reactComponentRef.current.updateState(true);
    //                 }

    //             });

    //             scope.$on('$destroy', function () {
    //                 // ReactDOM.unmountComponentAtNode(element[0]);
    //                 if (root) {
    //                     root.unmount();
    //                     root = null;
    //                 }
    //             });
    //         }
    //     };
    // })
    .directive('obTimeline', function () {
        return {
            link: function (scope, element, attrs) {
                let root;
                const reactComponentRef = React.createRef();
                if (!root) {
                    console.log(1);
                    root = createRoot(element[0]);
                    root.render(<TimelineComponent ref={reactComponentRef} />);
                }

                if (reactComponentRef.current) {
                    reactComponentRef.current.updateState(true);
                }

                scope.$on('$destroy', function () {
                    if (root) {
                        root.unmount();
                        root = null;
                    }
                });
            }
        };
    })
    .directive('obAlert', function () {
        return {
            scope: {
                state: '=',
                message: '=',
                type: '@',
                title: '@'
            },
            link: function (scope, element, attrs) {
                const reactComponentRef = React.createRef();
                let root = null
                if (!root) {
                    root = createRoot(element[0]);
                    // console.log(scope.state)
                    root.render(<AlertComponent state={scope.state} message={scope.message} ref={reactComponentRef} />);
                }
                scope.$watch('state', function (newValue) {
                    // console.log(newValue);
                    if (root && reactComponentRef.current && newValue === true) {
                        reactComponentRef.current.updateStateAttributes(true, scope.type, scope.title, scope.message);
                    }
                });

                scope.$on('$destroy', function () {
                    if (root) {
                        root.unmount();
                        root = null;
                    }
                });
            }
        };
    })
    .directive('obLabelInfo', function () {
        return {
            link: function (scope, element, attrs) {
                let root;
                const reactComponentRef = React.createRef();
                if (!root) {
                    // console.log(1);
                    root = createRoot(element[0]);
                    root.render(<LabelInformation attributes={attrs} ref={reactComponentRef} />);
                }

                if (reactComponentRef.current) {
                    reactComponentRef.current.updateState(true);
                }

                scope.$on('$destroy', function () {
                    if (root) {
                        root.unmount();
                        root = null;
                    }
                });
            }
        };
    })
    .directive('stickyRow', ['$window', '$rootScope', function ($window, $rootScope) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                const threshold = $window.innerHeight * 0.2;
                function onScroll() {
                    if ($window.pageYOffset > threshold) {
                        if ($rootScope.ob.menuTop && !element.hasClass('ob-sticky-row-menu-top')) {
                            element.addClass('ob-sticky-row-menu-top');
                        }
                        if (!$rootScope.ob.menuTop && !element.hasClass('ob-sticky-row')) {
                            element.addClass('ob-sticky-row');
                        }
                    } else {
                        element.removeClass('ob-sticky-row');
                        element.removeClass('ob-sticky-row-menu-top');
                    }
                }

                angular.element($window).on('scroll', onScroll);

                // Clean up
                scope.$on('$destroy', function () {
                    angular.element($window).off('scroll', onScroll);
                });
            }
        };
    }]);